import { Routes } from '@angular/router';
import { tabsRoutes } from './tabs/tabs.routes';
import { authRedirectGuard } from './common/guard/auth-redirect.guard';

export const routes: Routes = [
  {
    // decides login vs home based on whether a token already exists, instead of
    // always dumping a signed-in user back on the login screen
    path: '',
    canActivate: [authRedirectGuard],
    children: [],
    pathMatch: 'full'
  },
  // {
  //   path: 'landing',
  //   loadComponent: () => import('./auth/landing/landing.component').then(m => m.LandingComponent)
  // },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'otp',
    loadComponent: () => import('./auth/otp/otp.component').then(m => m.OtpComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./auth/signup/signup.component').then(m => m.SignupComponent)
  },
  // {
  //   path: 'profile',
  //   loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)

  // },
  // {
  //   path: 'my-profile',
  //   loadComponent: () => import('./my-profile/my-profile.component').then(m => m.MyProfileComponent)

  // },
  //  {
  //   path: 'farm-information',
  //   loadComponent: () => import('./profile/farm-information/farm-information.component').then(m => m.FarmInformationComponent)

  // },
  // {
  //   path: 'profile/farm-information',
  //   loadComponent: () =>
  //     import('./profile/farm-information/farm-information.component')
  //       .then(m => m.FarmInformationComponent)
  // },
  // {
  //   path: 'profile/farm-information/my-farms',
  //   loadComponent: () =>
  //     import('./profile/farm-information/my-farms/my-farms.component')
  //       .then(m => m.MyFarmsComponent)
  // },
  // {
  //   path: 'profile/farm-information/land-details',
  //   loadComponent: () =>
  //     import('./profile/farm-information/land-details/land-details.component')
  //       .then(m => m.LandDetailsComponent)
  // },
  // {
  //   path: 'my-activity',
  //   loadComponent: () => import('./profile/my-activity/my-activity.component').then(m => m.MyActivityComponent)

  // },

  // {
  //   path: 'feedback',
  //   loadComponent: () => import('./profile/feed-back/feed-back.component').then(m => m.FeedBackComponent)

  // },
  // {
  //   path: 'othersettings',
  //   loadComponent: () => import('./profile/other-settings/other-settings.component').then(m => m.OtherSettingsComponent)

  // },

  {
    path: 'tabs',
    loadComponent: () => import('./tabs/tabs.page').then(m => m.TabsPage),
    children: tabsRoutes
  },
  {
    path: '**',
    redirectTo: 'landing'
  }
];

